import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

const { spacing } = THEME;

export const styleSheet = StyleSheet.create({
	breadcrumbsBar: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.lg,
		paddingRight: spacing.md,
	},
});
